import { render, staticRenderFns } from "./manage-groups-page.vue?vue&type=template&id=5ef4cb2b"
import script from "./manage-groups-page.vue?vue&type=script&lang=js"
export * from "./manage-groups-page.vue?vue&type=script&lang=js"
import style0 from "./manage-groups-page.vue?vue&type=style&index=0&id=5ef4cb2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports